module.exports = __webpack_public_path__ + "img/vector_bg.6c5b4da0.svg";